// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"c2209095","739":"7ffb3799"}[chunkId] + ".chunk.js";
};